<template>
  <div>
    <mu-dialog :open="true" title="修改信息"  scrollable dialogClass="dialog-horizon-change" bodyClass='change-info'>
      <mu-flexbox orient="vertical">
        <mu-flexbox-item>
          &nbsp;
        </mu-flexbox-item>
        <mu-flexbox-item>
          <mu-text-field
            label="姓名"
            :errorText = "fieldErrorMessages.name"
            @input = 'validateFormModels'
            name="姓名"
            v-model="editName"
            @change="keyupHandler('editName',
            editName)"
          />
          <br/>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <!-- <datePickerEl :defaults="caseInfo.birthday" :label="dateName" @changeDate="getBirthday"></datePickerEl> -->
          <!-- <span class="is-danger" style="margin-left:150px;">{{ $parent.errorDate}}</span> -->
          <div class="birthday">
            <mu-text-field class="c-year" v-model="c_year" label="出生日期" /><span>年</span><mu-text-field v-model="c_month" class="c-month" /><span>月</span><mu-text-field v-model="c_day" class="c-day"/><span>日</span>
          </div>
          <span class="is-danger" v-if="showError">
            {{errorContent}}
          </span>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <checkBlock :label="select.gender.name" :value="caseInfo.gender" :options="select.gender.options" :flag="select.gender.flag" @changeVal="getChange"></checkBlock>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <radios :label="select.edus.name" :options="select.edus.options" :value="caseInfo.education" :flag="select.edus.flag" @changeVal="getChange"></radios>
        </mu-flexbox-item>
        <!-- <mu-flexbox-item>
          <radios :label="select.hands.name" :options="select.hands.options" :value="caseInfo.hand" :flag="select.hands.flag" @changeVal="getChange"></radios>
        </mu-flexbox-item> --> 
      </mu-flexbox>
      <mu-raised-button label="取消" @click="cancelHandler" style="margin-left:20px;color:#999;" slot="actions" />
      <mu-raised-button
        label="确认"
        @click="saveInfo"
        :disabled = 'isChange === false || allowSubmit === false'
        slot="actions"
        primary
      />
    </mu-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'
  import datePickerEl from '../../../common/datePickerEl.vue'
  import checkBlock from '../../../common/checkBlock.vue'
  import radios from '../../../common/radios.vue'

  export default ({
    props: ['caseInfo'],
    data() {
      return {
        editName: '',
        editAge: '',
        editSex: '1',
        editCount: '',
        editPass: '',
        editPhone: '',
        editEdu: '',
        editHand: '',
        editDate: '',
        showDate: false,
        dateName: "出生日期",
        //用于判断是否有属性值更改
        isChange: false,
        //用于标识isChange变为true是由那个属性引起的
        cause: '',
        //初始值
        initData: {},
        fieldErrorMessages: {
          name: '',
        },
        allowSubmit: false,
        select: GLOBAL.selectOption,
        c_year:"",
        c_month:"",
        c_day:"",
        showError:"",
        errorContent:"出生日期格式有误或大于今日",
      }
    },
    components:{
      checkBlock,
      radios,
      datePickerEl
    },
    created(){
      this.combination(this.caseInfo.birthday);
    },
    mounted() {
      this.editInfo();
      this.getBirthday(this.caseInfo.birthday); //出生日期的格式与其他字段不同，需手动触发事件将按钮高亮
    },
    methods: {
      combination:function(birthday){
        var date = birthday.split('-');
        this.c_year = date[0];
        this.c_month = date[1];
        this.c_day = date[2];
      },
      validateFormModels: function()
      {
        let ret = true;
        for (let fieldKey in this.fieldErrorMessages)
        {
          this.fieldErrorMessages[fieldKey] = '';
        }
        //TODO validate name
        if (0 === this.editName.trim())
        {
          this.fieldErrorMessages.name = '请输入姓名';
          ret = false;
        }
        else if (false == /^[\u4E00-\u9FA5\uF900-\uFA2D\w]+$/.test(this.editName.trim()))
        {
          this.fieldErrorMessages.name = '“必填项，请填写姓名';
          ret = false;
        }
        this.allowSubmit = ret;
        return ret;
      },
      editInfo: function() {
        this.editName    = this.caseInfo.name;
        this.editAge     = this.caseInfo.birthday;
        this.editSex     = this.caseInfo.gender;
        this.editPhone   = this.caseInfo.telephone;
        this.editEdu     = this.caseInfo.education;
        this.editHand    = this.caseInfo.hand;
        this.editDate    = this.caseInfo.expire
        this.initData={
          editName: this.editName,
          /* editAge: this.editAge, */
          editSex: this.editSex,
          editEdu: this.editEdu,
          editHand: this.editHand
        };
      },
      saveInfo: function() {
        var self = this;
        this.$validator.validateAll()
          .then(function(isValid){
            if (false == isValid)
            {
              return;
            }if(self.check_birthday()){
              self.$http.post('/api/Cases/update', {
                'id': self.$route.params.id,
                'name':self.editName,
                'path': '',
                'birthday': self.editAge,
                'gender': self.editSex,
                'telephone': self.editPhone,
                'education':self.editEdu,
                'hand':self.editHand
              },{emulateJSON: true})
              .then(function(){
                this.$emit("submitData");
              })
            }else{
              return
            }
          })
      },
      check_birthday(){
        var check_year = /\d{4}/; //年匹配4位数
        var check_month = /\d{2}/; //月匹配2位数
        var check_day = /\d{2}/; //日匹配2位数
        if(this.c_month < 10 && this.c_month.length == 1){
          this.c_month = `0${this.c_month}`;
        }
        if(this.c_day < 10 && this.c_day.length == 1){
          this.c_day = `0${this.c_day}`;
        }
        if(
          check_year.test(this.c_year) &&
          check_month.test(this.c_month) &&
          parseInt(this.c_month) < 13 &&
          parseInt(this.c_month) > 0 &&
          check_day.test(this.c_day) &&
          parseInt(this.c_day) < 32 &&
          parseInt(this.c_day) > 0
        ){
          this.showError = false;
          this.editAge = `${this.c_year}-${this.c_month}-${this.c_day}`;
          /* 比较填写的出生日期是否大于当天 */
          var birth_day = new Date();
          birth_day.setFullYear(this.c_year,this.c_month-1,this.c_day);
          var today = new Date();
          if(birth_day < today){
            return true;
          }else{
            this.showError = true;
            return false;
          }
          console.log(this.editAge);
        }else{
          this.showError = true;
          return false;
        }
      },
      getChange: function(option,flag){
        console.log(option,flag)
        let key = '';
        switch (flag) {
          case 'edus':
            this.editEdu = option;
            key = "editEdu";
            break;
          case 'hands':
            this.editHand = option;
            key = "editHand";
            break;
          case 'gender':
            this.editSex = option;
            key = "editSex";
            break;
          default:
            break;
        }
        this.changeHandler(key, option);
      },
      getDate:function(item){
        console.log("caseinfo: " + item);
        var self = this;
        this.editDate = item;
        self.$http.post('/api/Cases/updateValidTime', {
            'id': self.$route.params.id,
            'validDay':self.editDate
          },{emulateJSON: true})
          .then(function(){
            self.showDate = false;
            location.reload();
          })
      },
      changeDate: function(){
        this.showDate = true;
      },
      // 获取选择的生日
      getBirthday: function(item){
        this.changeHandler("editAge", item);
        this.editAge = item;
      },
      //change事件处理函数
      keyupHandler(key, value) {
        this.changeHandler(key, value);
      },
      //判断是否有值发生改变
      changeHandler(key, value){
        if(value!=this.initData[key]){
          this.isChange = true;
          return false;
        }
        for(var initKey in this.initData){
          if(this[initKey]!=this.initData[initKey]){
            this.isChange = true;
            break;
          }
          this.isChange = false;
        }
      },
      cancelHandler() {
        this.$emit("close");
        this.isChange = false;
        $("input").blur();
      }
    }
  })
</script>
<style lang="stylus" scoped>
  @import "../../../../assets/css/app.styl"

</style>
<style>
  .c-year,.c-month,.c-day{
    width:65px !important;
    margin-right: 10px !important;
  }
  .c-month,.c-day{
    margin-left: 10px;
  }
  .c-year .mu-text-field-input,.c-month .mu-text-field-input,.c-day .mu-text-field-input{
    text-align: center;
  }
  .dialog-horizon-change{
    max-height:540px !important;
    height: 540px !important;
  }
  .dialog-horizon-change .is-danger{
    color: #f44336;
    font-size: 12px;
    line-height: 12px;
    margin-left: 0;
  }
  .change-info{
    height: 400px !important;
    max-height: 400px !important;
    overflow: auto;
    background-color: #fff;
  }
</style>




// WEBPACK FOOTER //
// caseInfoModal.vue?0ee6146c